module.exports = __webpack_public_path__ + "static/media/PoliMi.775118b8.png";